theme.video=function(){function welcomeVideo(){const lightbox=GLightbox({touchNavigation:!0,lightboxHTML:`<div id="glightbox-body" class="glightbox-container">
    <div class="gloader visible"></div>
    <div class="goverlay"></div>
    <div class="gcontainer">
    <div id="glightbox-slider" class="gslider"></div>
    <button class="gnext gbtn" tabindex="0" aria-label="Next" data-customattribute="example">{nextSVG}</button>
    <button class="gprev gbtn" tabindex="1" aria-label="Previous">{prevSVG}</button>
    <button class="gclose gbtn" tabindex="2" aria-label="Close">{closeSVG}</button>
    </div>
    </div>`,loop:!0})}return welcomeVideo}();
//# sourceMappingURL=/s/files/1/0740/5053/5715/t/16/assets/welcome-video.js.map?v=1762509984
